// client/src/components/admin/OrganizationManagement.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const OrganizationManagement = () => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const res = await axios.get('/api/admin/organizations');
        setOrganizations(res.data.organizations);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch organizations');
        setLoading(false);
      }
    };

    fetchOrganizations();
  }, []);

  const toggleOrganizationStatus = async (orgId, currentStatus) => {
    try {
      await axios.put(`/api/admin/organizations/${orgId}`, {
        isActive: !currentStatus
      });

      // Update organization list
      setOrganizations(organizations.map(org => 
        org._id === orgId ? { ...org, isActive: !org.isActive } : org
      ));
    } catch (err) {
      setError('Failed to update organization status');
    }
  };

  // ✅ AGGIUNTA: Funzione per determinare lo status KYC
  /*const getKycStatus = (organization) => {
    if (organization.type === 'bank') {
      return { status: 'N/A', className: 'status-neutral' };
    }
    
    if (!organization.kyc || !organization.kyc.status) {
      return { status: 'Not Started', className: 'status-pending' };
    }
    
    switch (organization.kyc.status) {
      case 'completed':
        return { status: 'Completed', className: 'status-approved' };
      case 'in_progress':
        return { status: 'In Progress', className: 'status-pending' };
      case 'review_required':
        return { status: 'Review Required', className: 'status-warning' };
      default:
        return { status: 'Not Started', className: 'status-pending' };
    }
  };*/

  if (loading) {
    return <div className="loading">Loading organizations...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="admin-container">
      <h2 className="admin-page-title">Organization Management</h2>
      
      <div className="admin-card">
        <div className="admin-card-header">
          <h3 className="admin-card-title">All Organizations</h3>
        </div>
        <div className="admin-card-body">
          <div className="admin-table-responsive">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Organization ID</th>
                  <th>Contact Email</th>
                  <th>Status</th>
                  <th>Actions</th>
                  <th>Details</th>
                  {/*<th>KYC</th> ✅ AGGIUNTA: Nuova colonna */}
                </tr>
              </thead>
              <tbody>
                {organizations.length > 0 ? (
                  organizations.map(org => {
                    return (
                      <tr key={org._id}>
                        <td>{org.name}</td>
                        <td>{org.type === 'bank' ? 'Bank' : 'Company'}</td>
                        <td>{org.organizationId}</td>
                        <td>{org.contactEmail}</td>
                        <td>
                          <span className={`status ${org.isActive ? 'status-approved' : 'status-rejected'}`}>
                            {org.isActive ? 'Active' : 'Inactive'}
                          </span>
                        </td>
                        <td>
                          <button
                            className={`btn ${org.isActive ? 'btn-danger' : 'btn-primary'} btn-sm`}
                            onClick={() => toggleOrganizationStatus(org._id, org.isActive)}
                          >
                            {org.isActive ? 'Deactivate' : 'Activate'}
                          </button>
                        </td>
                        <td>
                          <Link to={`/admin/organizations/${org._id}`} className="btn btn-light btn-sm">
                            Details
                          </Link>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="7">No organizations found</td>{/* ✅ MODIFICA: cambiato da 7 a 8 per la nuova colonna */}
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationManagement;